import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const navLinks = [
    { label: "About", path: "/about" },
    { label: "Team", path: "/team" },
    { label: "How It Works", path: "/how-it-works" },
    { label: "Benefits", path: "/benefits" },
    { label: "Features", path: "/features" },
    { label: "Components", path: "/component" },
    { label: "Templates", path: "/templates" },
    { label: "Figma", path: "/figma" },
];

const NavbarWithMenu = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [location.pathname]);

    const handleLinkClick = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const handleMobileLinkClick = () => {
        setIsMenuOpen(false);
        handleLinkClick();
    };

    return (
        <header className="fixed top-16 left-0 w-full z-50 bg-black bg-opacity-90 h-24">
            <div className="w-full flex items-center justify-between h-full px-4 sm:px-6 lg:px-8">
                <NavLink to="/" onClick={handleLinkClick} className="flex-shrink-0 ml-4">
                    <img
                        src="/pixui-logo.svg"
                        alt="PixUI Logo"
                        className="h-12"
                    />
                </NavLink>

                <div className="hidden lg:flex items-center h-full mr-4">
                    <nav className="flex h-full">
                        {navLinks.map((link) => (
                            <NavLink
                                key={link.path}
                                to={link.path}
                                onClick={handleLinkClick}
                                className={({ isActive }) =>
                                    `relative h-full px-6 py-3 text-sm font-semibold uppercase transition-all duration-300 group flex items-center ${isActive
                                        ? "text-black bg-amber-400 rounded-b-md"
                                        : "text-white hover:text-black"}`
                                }
                            >
                                <span className="absolute inset-0 bg-amber-400 scale-y-0 origin-top transition-transform duration-300 group-hover:scale-y-100 z-0 rounded-b-md"></span>
                                <span className="relative z-10">{link.label}</span>
                            </NavLink>
                        ))}
                    </nav>
                </div>

                <div className="lg:hidden">
                    <button
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        className="text-white focus:outline-none"
                        aria-label="Toggle menu"
                    >
                        {isMenuOpen ? (
                            <svg
                                className="w-8 h-8"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                ></path>
                            </svg>
                        ) : (
                            <svg
                                className="w-8 h-8"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h16m-7 6h7"
                                ></path>
                            </svg>
                        )}
                    </button>
                </div>
            </div>

            <motion.div
                animate={isMenuOpen ? "open" : "closed"}
                initial={false}
                variants={{
                    open: { opacity: 1, y: 0 },
                    closed: { opacity: 0, y: "-100%" },
                }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="lg:hidden absolute top-24 left-0 w-full bg-black bg-opacity-95"
                style={{ pointerEvents: isMenuOpen ? "auto" : "none" }}
            >
                <nav className="flex flex-col items-center p-4">
                    {navLinks.map((link) => (
                        <NavLink
                            key={link.path}
                            to={link.path}
                            onClick={handleMobileLinkClick}
                            className={({ isActive }) =>
                                `w-full text-center py-4 text-lg font-semibold uppercase transition-all duration-300 rounded-md ${isActive
                                    ? "bg-amber-500 text-black"
                                    : "text-white hover:bg-neutral-800"
                                }`
                            }
                        >
                            {link.label}
                        </NavLink>
                    ))}
                </nav>
            </motion.div>
        </header>
    );
};

export default NavbarWithMenu;
